<template>
  <div class="pageContent">
    <inspectionReportStemp v-if="Storage.get('code') != 2 && Storage.get('examStatus') != 1" />
  </div>
</template>
<script>
import inspectionReportStemp from '@/components/reportInfo/inspectionReportStemp.vue'
import Storage from '@/tools/storage'
export default {
  name: 'reportInfo',
  components: { inspectionReportStemp },
  data() {
    return {}
  }
}
</script>
<style scoped>
</style>
